import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from 'antd';
import { NEW_TEMPLATE_SECTION } from './translationValues';
import {
  TagSearchContainer,
  TagsWrapper,
  TagBadge,
  RemoveButton,
  InputWrapper,
  StyledInput,
} from './styles';

export function TagSearch({ selectedTags, onTagsChange }) {
  const { t } = useTranslation(['NEW_TEMPLATE_SECTION']);
  const [inputValue, setInputValue] = useState('');

  const addTag = tag => {
    if (!selectedTags.includes(tag)) {
      onTagsChange([...selectedTags, tag]);
    }
    setInputValue('');
  };

  const removeTag = tagToRemove => {
    onTagsChange(selectedTags.filter(tag => tag !== tagToRemove));
  };

  const handleKeyDown = e => {
    if (e.key === 'Enter' && inputValue.trim()) {
      addTag(inputValue.trim().toLowerCase());
    }
  };

  return (
    <TagSearchContainer>
      {/* Selected Tags */}
      {selectedTags.length > 0 && (
        <TagsWrapper hasItems={true}>
          {selectedTags.map(tag => (
            <TagBadge key={tag}>
              <span>{tag}</span>
              <RemoveButton onClick={() => removeTag(tag)}>
                <Icon type="close" size={12} />
              </RemoveButton>
            </TagBadge>
          ))}
        </TagsWrapper>
      )}

      {/* Search Input */}
      <InputWrapper>
        <StyledInput
          value={inputValue}
          onChange={e => setInputValue(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder={t(
            NEW_TEMPLATE_SECTION.PLACEHOLDER_SEARCH_BY_TAGS.key,
            NEW_TEMPLATE_SECTION.PLACEHOLDER_SEARCH_BY_TAGS.value,
          )}
        />
      </InputWrapper>
    </TagSearchContainer>
  );
}
